// Copyright (c) 2025 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { useUtilityAutomationClient } from '../../contexts/UtilityAutomationApiContext';
import { UtilityBackend } from '../../utils/UtilityAutomationApiClient';

// Copyright (c) 2025 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0

export const useDeleteUnresponsiveParties: () => UseMutationResult<
  void,
  string,
  {
    backend: UtilityBackend;
    partyIds: string[];
  }
> = () => {
  const api = useUtilityAutomationClient();

  return useMutation({
    mutationKey: ['deleteUnresponsiveParties', api],
    mutationFn: async ({ backend, partyIds }) => {
      await api.deleteUnresponsiveParties(backend, partyIds);
    },
  });
};
